import { useEffect, useMemo, useState } from "react";
import constants from "../constants";
import { getStorage } from "utils";
import {
  getOfficeNavigationContext,
  isInOfficeNavigationContext,
  OFFICE_NAV_CONTEXT_CHANGE_EVENT,
} from "utils/officeNavigationContext";
export default function useStaffAvailabilityFilter() {
  //Office Filter for YourScheduler-Agenda
  let cachedFilters =
    sessionStorage.getItem(
      constants.localStorageKeys.staffAvailablilityFilter
    ) || null;

  cachedFilters = cachedFilters
    ? JSON.parse(cachedFilters)
    : { apiOffices: [], apiEmps: [] };

  const [selectedOfficeFilter, setOfficeFilter] = useState(
    cachedFilters.apiOffices
  );
  const [usersList, setUsersList] = useState([]);
  const [selectedEmpFilter, setEmpFilter] = useState(cachedFilters.apiEmps);
  const [apiOffices, setApiOffices] = useState(cachedFilters.apiOffices);
  const [apiEmps, setApiEmps] = useState(cachedFilters.apiEmps);
  const [employeeList, setEmployeeList] = useState([]);
  const [appliedOfficeFilter, setAppliedOfficeFilter] = useState(
    cachedFilters.apiOffices
  );
  const [appliedStaffFilter, setAppliedStaffFilter] = useState(
    cachedFilters.apiEmps
  );
  const [selectedRoles, setSelectedRoles] = useState([]);

  const resetFilters = () => {
    setOfficeFilter([]);
    setEmpFilter([]);
    setApiEmps([]);
    setApiOffices([]);
    setAppliedOfficeFilter([]);
    setAppliedStaffFilter([]);
  };

  useEffect(() => {
    const dataToCache = {
      apiOffices,
      apiEmps,
    };
    sessionStorage.setItem(
      constants.localStorageKeys.staffAvailablilityFilter,
      JSON.stringify(dataToCache)
    );
  }, [apiOffices, apiEmps]);

  useEffect(() => {
    const officeContext = getOfficeNavigationContext();
    if (isInOfficeNavigationContext(officeContext) && officeContext?.officeId) {
      setOfficeFilter([officeContext.officeId]);
      setAppliedOfficeFilter([officeContext.officeId]);
    }
  }, []);

  useEffect(() => {
    const syncOfficeFiltersFromContext = () => {
      const officeContext = getOfficeNavigationContext();
      if (isInOfficeNavigationContext(officeContext) && officeContext?.officeId) {
        setOfficeFilter([officeContext.officeId]);
        setAppliedOfficeFilter([officeContext.officeId]);
        return;
      }
      const cachedFilters =
        sessionStorage.getItem(
          constants.localStorageKeys.staffAvailablilityFilter,
        ) || null;
      const parsed = cachedFilters
        ? JSON.parse(cachedFilters)
        : { apiOffices: [], apiEmps: [] };
      setOfficeFilter(parsed.apiOffices || []);
      setAppliedOfficeFilter(parsed.apiOffices || []);
      setApiOffices(parsed.apiOffices || []);
    };
    window.addEventListener(
      OFFICE_NAV_CONTEXT_CHANGE_EVENT,
      syncOfficeFiltersFromContext,
    );
    return () =>
      window.removeEventListener(
        OFFICE_NAV_CONTEXT_CHANGE_EVENT,
        syncOfficeFiltersFromContext,
      );
  }, []);

  const userIdsSelected = useMemo(() => {
    return usersList.reduce(
      (prev, curr) => {
        const value = apiEmps.some((res) => res === curr.id);
        const id = curr.userId ?? curr.id;
        if (value && !prev.keyPair.has(id)) {
          prev.returnedArray.push(id);
          prev.keyPair.set(id, id);
        }
        return prev;
      },
      {
        returnedArray: [],
        keyPair: new Map(),
      }
    ).returnedArray;
  }, [apiEmps, usersList]);
  return {
    selectedOfficeFilter,
    selectedEmpFilter,
    apiOffices,
    apiEmps: userIdsSelected,
    employeeList,
    appliedOfficeFilter,
    appliedStaffFilter,
    selectedRoles,
    setOfficeFilter,
    setEmpFilter,
    setApiOffices,
    setApiEmps,
    resetFilters,
    setEmployeeList,
    setAppliedOfficeFilter,
    setAppliedStaffFilter,
    setSelectedRoles,
    usersList,
    setUsersList,
  };
}
